<template>
    <DropdownSelect
        class="flex-fill"
        :data="internalData"
        caption="general.none"
        v-model="value"
        :show-search="showSearch && internalData.length > 10"
        :virtual-scroller-max-items="30"
    />
</template>
<script setup lang="ts">
import { type IEditorComponent } from '@/objects/gui';
import { DropdownSelect } from '@/components';
import type { SelectLine, SelectLineValueType } from '@/objects';
import type { ISelectLineDatasource } from '@/objects/ISelectLineDatasource';
import { computed, ref, watch, type ComponentPublicInstance } from 'vue';

defineOptions({ inheritAttrs: false });

const props = withDefaults(
    defineProps<{
        /**
         * The datasource for the select
         */
        datasource: ISelectLineDatasource;

        /**
         * If the search should be shown
         */
        showSearch?: boolean;
    }>(),
    {
        showSearch: true,
    },
);

const value = defineModel<SelectLineValueType | SelectLineValueType[]>({ required: true });

// The ref of the input element
const inputref = ref<ComponentPublicInstance<IEditorComponent> | null>(null);

const internalData = ref<SelectLine[]>([]);

defineEmits<{
    (e: 'update:modelValue', modelValue: number | string | null): void;
}>();

//  Makre sure we can handle changes to the source
watch(
    () => props.datasource,
    (newVal) => {
        internalData.value = newVal.source ?? Array.from(newVal.mapsource?.values() ?? []);
    },
    { immediate: true, deep: true },
);

defineExpose<IEditorComponent>({ focus: () => inputref.value?.focus(), validateMessage: computed(() => null) });
</script>
